import { computed, ref, type ComputedRef, type Ref } from 'vue'

import type { Stat } from '@collector/sportsapi-types'

export function useParticipantStatUpdate(stat: Ref<Stat>): {
  isEventStatUpdated: ComputedRef<boolean>
  updateStat: (value: Stat) => void
} {
  // state
  const statLocal = ref(stat.value.value)

  // computed
  const isEventStatUpdated = computed(
    () => Number(stat.value.value) !== Number(statLocal.value),
  )

  // methods
  function updateStat(value: Stat): void {
    stat.value = value
    statLocal.value = value.value
  }

  return {
    isEventStatUpdated,
    updateStat,
  }
}
